import { AutogenModelCarrierObjection, AutogenRowCarrierObjection } from "./autogen/AutogenModelCarrierObjection";

export class ModelCarrierObjection extends AutogenModelCarrierObjection<RowCarrierObjection> {
	constructor() {
		super(RowCarrierObjection);
	}
}

export class RowCarrierObjection extends AutogenRowCarrierObjection {
}